import React from "react";
import { FaCodeBranch, FaCloudArrowUp, FaChartLine, FaMagnifyingGlassChart, FaBuildingColumns } from "react-icons/fa6";

const ProductsAndServices = ({ MarginTop }) => {

    return (
        <section id="productsAndServices" style={{ scrollMarginTop: MarginTop }}>
            <div className='home-section our_services_sec'>
                <div className="section-badge">
                    <span className="title-side-line"></span>
                    <h5 className="badge-text">Products and Services</h5>
                    <span className="title-side-line"></span>
                </div>
                <div className="title-section">
                    <h1 className="head-title">Complete <span>Lending Lifecycle</span> Management</h1>
                    <span className="title-under-line"></span>
                    <p className="title-disc">Our platform is designed to handle every stage of your lending operations. From the first customer inquiry to final loan recovery. Whether you need an
                        end-to-end solution or specific modules to enhance your existing infrastructure, we offer the flexibility to match your requirements.</p>
                </div>
                <div className="prduct-dflx-box">
                    <div className="pruct-box wid-65">
                        <div className="service-item">
                            <div className="service-icon">
                                <FaBuildingColumns />
                            </div>
                            <div className="service-divider"></div>
                            <div className="service-content">
                                <h4> Loan Origination System (LOS) </h4>
                                <div className="service-line"></div>
                                <p>
                                    Streamline your entire loan origination process with our
                                    comprehensive LOS that takes you from lead capture through
                                    disbursement. Manage leads and prospects efficiently, move
                                    seamlessly through underwriting and credit evaluation,
                                    generate detailed Credit Appraisal Memos (CAM), and process
                                    loan disbursements, all within a single, intuitive platform.
                                    Our infinitely configurable workflows adapt to your unique
                                    lending products and processes, while our lightning-fast
                                    interface keeps your team productive.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="pruct-box wid-35">
                        <div className="service-item">
                            <div className="service-icon">
                                <FaChartLine />
                            </div>
                            <div className="service-divider"></div>
                            <div className="service-content">
                                <h4> Collection and Debt Recovery System </h4>
                                <div className="service-line"></div>
                                <p>
                                    Lending is easy; getting paid back is the work. Our Collection and Debt Recovery System is purpose-built to maximize
                                    recovery rates through rigorous tracking and automation.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="horiz-service-divider"></div>
                <div className="prduct-dflx-box">
                    <div className="pruct-box">
                        <div className="service-item">
                            <div className="service-icon">
                                <FaCodeBranch />
                            </div>
                            <div className="service-divider"></div>
                            <div className="service-content">
                                <h4> Integration Framework </h4>
                                <div className="service-line"></div>
                                <p>
                                    Connect seamlessly with the services and systems you already use. Our robust integration framework links your lending
                                    operations with KYC providers, banks, payment gateways, credit bureaus, and other essential third-party
                                    services. Built for reliability and scalability, our integration layer ensures smooth data flow across
                                    your entire lending ecosystem without the headaches of custom development.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="pruct-box">
                        <div className="service-item">
                            <div className="service-icon">
                               <FaMagnifyingGlassChart /> 
                            </div>
                            <div className="service-divider"></div>
                            <div className="service-content">
                                <h4> Bank Statement Analyzer </h4>
                                <div className="service-line"></div>
                                <p>
                                    Make faster, smarter lending decisions with our intelligent bank statement reader. Simply upload a borrower's bank statement and our system automatically analyzes their financial status,
                                    cash flow patterns, and creditworthiness. What used to take hours of manual review now happens in minutes, giving you accurate
                                    insights to support better underwriting decisions.
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="pruct-box">
                        <div className="service-item">
                            <div className="service-icon">
                                <FaCloudArrowUp />
                            </div>
                            <div className="service-divider"></div>
                            <div className="service-content">
                                <h4> Flexible Deployment Options</h4>
                                <div className="service-line"></div>
                                <p>
                                    Every lender is different, and we respect that. You can implement our complete suite as a unified platform for end-to-end lending management, or select individual modules that address your specific needs.
                                    Our services are designed to work together seamlessly or stand alone, giving you the freedom to build the solution that's right for your
                                    institution, today and as you grow.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )

}

export default ProductsAndServices;